import React from 'react';
import NCERTBooksLanding from './NCERTBooksLanding';

function App() {
  return <NCERTBooksLanding />;
}

export default App;
